module.exports = __webpack_public_path__ + "static/media/sitio-mantenimiento-md.c7ef7734.png";